import { StatementOfAccessibilityPage } from "./StatementOfAccessibilityPage";

export default function StatementOfAccessibility(){
    return(
        <StatementOfAccessibilityPage/>
    );
}